import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const API = process.env.REACT_APP_BACKEND_URL;
const isSnap = typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap';
const LEAD_PATHS = ['/api/contact', '/api/quotes', '/api/cloud-access', '/api/support', '/api/newsletter/subscribe'];

const getVid = () => {
  try {
    let v = localStorage.getItem('daakyi_vid');
    if (!v) {
      v = (crypto.randomUUID && crypto.randomUUID()) || `v-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
      localStorage.setItem('daakyi_vid', v);
    }
    return v;
  } catch { return null; }
};

const send = (payload) => {
  try {
    fetch(`${API}/api/beacon`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      keepalive: true, body: JSON.stringify(payload)
    }).catch(() => {});
  } catch { /* noop */ }
};

let identityHooked = false;
const hookIdentity = (vid) => {
  if (identityHooked || typeof window.fetch !== 'function') return;
  identityHooked = true;
  const orig = window.fetch.bind(window);
  window.fetch = (...args) => {
    const promise = orig(...args);
    try {
      const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      const opts = args[1] || {};
      if ((opts.method || '').toUpperCase() === 'POST' && typeof opts.body === 'string'
          && LEAD_PATHS.some(lp => url.includes(lp))) {
        promise.then(res => {
          if (!res.ok) return;
          try {
            const b = JSON.parse(opts.body);
            const email = b.email || '';
            if (email) {
              send({ vid, event: 'identify', path: window.location.pathname,
                name: b.name || b.fullName || [b.firstName, b.lastName].filter(Boolean).join(' '), email,
                company: b.company || b.organization || '' });
            }
          } catch { /* not json */ }
        }).catch(() => {});
      }
    } catch { /* noop */ }
    return promise;
  };
};

export const VisitorPulse = () => {
  const { pathname } = useLocation();
  const sentRef = useRef(false);
  const lastView = useRef({ path: '', at: 0 });

  useEffect(() => {
    if (isSnap || pathname.startsWith('/ops-console') || pathname.startsWith('/deck/')) return;
    if (lastView.current.path === pathname && Date.now() - lastView.current.at < 3000) return;
    lastView.current = { path: pathname, at: Date.now() };
    const vid = getVid();
    if (!vid) return;
    hookIdentity(vid);
    const payload = { vid, event: 'view', path: pathname };
    if (!sentRef.current) {
      sentRef.current = true;
      try {
        payload.ref = document.referrer || '';
        const params = new URLSearchParams(window.location.search);
        payload.utm_source = params.get('utm_source') || '';
        payload.utm_medium = params.get('utm_medium') || '';
        payload.utm_campaign = params.get('utm_campaign') || '';
      } catch { /* noop */ }
    }
    send(payload);
  }, [pathname]);

  useEffect(() => {
    if (isSnap) return;
    const vid = getVid();
    if (!vid) return;
    const beat = () => {
      if (document.visibilityState !== 'visible') return;
      const p = window.location.pathname;
      if (p.startsWith('/ops-console') || p.startsWith('/deck/')) return;
      send({ vid, event: 'beat', path: p });
    };
    const timer = setInterval(beat, 20000);
    const onHide = () => {
      try {
        const blob = new Blob([JSON.stringify({ vid, event: 'leave', path: window.location.pathname })],
          { type: 'application/json' });
        navigator.sendBeacon(`${API}/api/beacon`, blob);
      } catch { /* noop */ }
    };
    window.addEventListener('pagehide', onHide);
    return () => { clearInterval(timer); window.removeEventListener('pagehide', onHide); };
  }, []);

  return null;
};
